import React, { useState, useEffect } from 'react';
import useComponentDidMount from 'Hooks/useComponentDidMount';

const FormField = ({
  value,
  label,
  formErrors,
  name,
  placeholder,
  onChange,
  handleValidation,
  className,
  required,
}) => {
  const isComponentMounted = useComponentDidMount();

  const [fieldFocused, setFieldFocused] = useState(false);
  const [fieldDirty, setFieldDirty] = useState(false);

  useEffect(() => {
    if (!isComponentMounted || !fieldDirty) {
      return;
    }
    handleValidation && handleValidation(value);
  }, [fieldFocused]);

  const error = formErrors?.[name];

  return (
    <div
      className={`${className} ${error && 'input--errors'}`}
    >
      <label htmlFor={name}>
        {label}
      </label>
      <input
        className={required ? 'required' : 'optional'}
        required={required ? 'required' : false}
        onChange={(e) => {
          if (fieldDirty) {
            handleValidation && handleValidation(e.target.value);
          }
          onChange(e);
        }}
        name={name}
        value={value}
        placeholder={placeholder}
        id={name}
        onBlur={() => {
          setFieldDirty(true);
          setFieldFocused(false);
        }}
        onFocus={() => {
          setFieldFocused(true);
        }}
      />
      {error && (<div className="error">{error}</div>)}
    </div>
  );
};

export default FormField;
